import { getContext } from '@fiverr-private/fiverr_context';
import { appTranslate } from '../../page/i18n';
import { BriefItem } from '../types/brief';

export const isCurrentUser = (userId?: number | string) => {
    const { userId: currUserId } = getContext();
    return currUserId?.toString() === userId?.toString();
};

export const getUserName = (user: BriefItem['createdBy']) => {
    const name = user.user?.fullName || user.user?.name;
    if (isCurrentUser(user?.id)) {
        return `${name} (${appTranslate('table.you')})`;
    }
    return name;
};

export const getCreatedByUserName = (user: BriefItem['createdBy']) => {
    if (isCurrentUser(user?.id)) {
        return appTranslate('table.created_by_you').toString();
    }
    const name = user.user?.fullName || user.user?.name;
    return appTranslate('table.created_by_name', {
        params: {
            name,
        },
    }).toString();
};
